import { AbortRef, errors, SimpleResult } from "@ryde/shared";

export const beginPollAbort = (ref: AbortRef): AbortController => {
  ref.current?.abort();
  const controller = new AbortController();
  ref.current = controller;
  return controller;
};
export const endPollAbort = (
  ref: AbortRef,
  controller: AbortController,
): void => {
  if (ref.current === controller) {
    ref.current = null;
  }
};
export const abortPollInFlight = (ref: AbortRef): void => {
  ref.current?.abort();
  ref.current = null;
};
export const isLiveMapRequestCanceled = (
  result: SimpleResult<unknown> | undefined,
): boolean => result?.error === errors.common.requestCanceled;
